import type { PreviewQuery } from "./api";

export const queryKeys = {
	quotes: ["quotes"] as const,
	portfolioSnapshot: ["portfolio.snapshot"] as const,
	walletBalances: ["walletBalances"] as const,
	rebalancePreview: (q: PreviewQuery) => ["rebalance.preview", q] as const,
	users: ["auth.users"] as const,
};
